import { Component, OnInit, ElementRef } from "@angular/core";
import { ROUTES } from "../super-admin-sidebar/super-admin-sidebar.component";
import { Location } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";
import * as SecureLS from "secure-ls";
import { UploadService } from "src/app/services/upload.service";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { GlobalService } from "src/app/services/global.service";
import { StorageService } from "../../services/storage.service";
import { IsPointV2, AppLogo1 } from "src/app/app.config";
import { roleIdSix } from "src/app/shared/constants/role.id.constants";
import CryptoJS from "crypto-js";
import { NgxSpinnerService } from "ngx-spinner";
import { SettingsFormModalComponent } from "../settings-form-modal/settings-form-modal.component";

@Component({
  selector: "app-general-navbar",
  templateUrl: "./general-navbar.component.html",
  styleUrls: ["./general-navbar.component.scss"],
})
export class GeneralNavbarComponent implements OnInit {
  public focus;
  public listTitles: any[];
  public location: Location;
  // preview_image: any;
  // preview_sub_image: any;
  pre_logo: any;
  pre_sub_logo: any;
  getroles: any;
  getroles_id: any;
  RoleChange: any[];
  selectedRole: any;
  multiRoleLogin: any;
  access: boolean = true;
  errorMessage: string = "";
  role_id: any;
  notificationList: any;
  appLogo = AppLogo1;
  notificationListArr: any;
  constructor(
    location: Location,
    private element: ElementRef,
    private router: Router,
    private upload: UploadService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private storageService: StorageService,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService
  ) {
    this.location = location;
  }
  private ls = new SecureLS({ encodingType: "aes" });
  firstname = this.ls.get("first_name");
  write_access = this.ls.get("write_access");
  lastname = this.ls.get("last_name");
  roleId = this.ls.get("role");
  vendorLogo = this.ls.get("vendor_logo");
  vendorsubLogo = this.ls.get("vendor_sub_logo");
  loginType: any;

  async ngOnInit() {
    if(this.storageService.notificationIntval !== undefined)
    this.getNotificationList();
    this.storageService.notificationIntval = setInterval(() => {
      this.getNotificationList();
    }, 180000);
    this.listTitles = ROUTES.filter((listTitle) => listTitle);
    // if (this.vendorLogo !== null && this.vendorLogo !== "") {
    //   this.preview_image = this.upload.generateAwsFileUrl(this.vendorLogo);
    //   this.pre_logo = this.preview_image.s3_url;
    // }
    // if (this.vendorsubLogo !== null && this.vendorsubLogo !== "") {
    //   this.preview_sub_image = this.upload.generateAwsFileUrl(
    //     this.vendorsubLogo
    //   );
    //   this.pre_sub_logo = this.preview_sub_image.s3_url;
    // }
    if (this.route.queryParams["value"].loginType == "impersonate") {
      this.loginType = "impersonate";
      this.firstname = this.ls.get("impersonate_first_name");
      this.lastname = this.ls.get("impersonate_last_name");
      this.roleId = this.ls.get("impersonate_role");
    }
    if (
      this.ls.get("is_multiple_role") == 0 ||
      this.loginType == "impersonate"
    ) {
      this.access = false;
    } else {
      this.access = true;
      this.getRoles();
    }
  }

  async getNotificationList() {
    let filter = {
      user_id: this.storageService.getCreatedBy(),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    let notificationList = await this.globalService.get(
      "classVideoDetail/list/notification",
      filter,
      true
    );
    if (notificationList["status"] == 200) {
      this.notificationListArr = notificationList["content"]["rows"];
    }
  }

  onClickSettingsIcon() {
    this.modalService.open(SettingsFormModalComponent, {
      scrollable: true
    });
  }

  async onNotificationClick(notification) {
    this.spinner.show();
    let filter = {
      user_id: this.storageService.getCreatedBy(),
      vendor_id: this.ls.get("vendor_id"),
      id: notification.id,
    };
    let updateNotification = await this.globalService.update(
      "classVideoDetail/update-notification",
      filter,
      true
    );
    if (updateNotification["status"] === 200) {
      this.spinner.hide();
      this.getNotificationList();
    }
    const encrypt = (text) => {
      return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text));
    };
    const enryptText =
      notification.notification_video_details.is_hls_video == 0
        ? "ZERO"
        : "ONE";
    window.open(
      `/video/play?key=${
        notification.class_room_video_details_id
      }&isHls=${encrypt(
        enryptText
      )}&loginType=${this.storageService.getImpersonateTextForUrl()}`,
      "_blank"
    );
  }

  getTitle() {
    var titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee.charAt(0) === "#") {
      titlee = titlee.slice(1);
    }

    for (var item = 0; item < this.listTitles.length; item++) {
      if (this.listTitles[item].path === titlee) {
        return this.listTitles[item].title;
      }
    }
    return "RegisteredVendors";
  }

  // onClickClose(index) {
  //   this.notificationListArr[index].isShow = false;
  // }

  logout(content: any) {
    this.modalService.open(content, { centered: true, size: "sm" });
  }

  roleChange(contentlist: any) {
    this.modalService.open(contentlist, { centered: true, size: "md" });
  }
  closeModal() {
    this.modalService.dismissAll();
  }
  async getRoles() {
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      id: this.ls.get("createdBy"),
      role_id: this.storageService.getRole(),
    };
    this.getroles = await this.globalService.get(
      "commonUser/get-roles",
      filter
    );
    if (this.getroles["status"] === 200) {
      this.RoleChange = this.getroles["content"]["userByRole"];
    }
  }

  async changeRoles(selectedRole) {
    if (!selectedRole) {
      this.errorMessage = "*Select a Role";
    } else {
      let multiRoleInputData = {
        user_id: this.ls.get("user_id"),
        role_id: selectedRole.userRole.role_id,
      };
      this.multiRoleLogin = await this.globalService.create(
        "user/multirole-user-login",
        multiRoleInputData,
        IsPointV2
      );
      let compData = this.multiRoleLogin["content"];
      let ven_profile =
        compData.user_info.college_profile !== null
          ? compData.user_info.college_profile.logo
          : "";
      let ven_sub_admin_profile =
        compData.user_info.vendor_detail != null
          ? compData.user_info.vendor_detail.logo
          : "";
      this.ls.set("token", compData.token);
      this.ls.set("refresh_token", compData.refresh_token);
      this.ls.set("hod", compData.user_info["hod"] ? "1" : "0");
      this.ls.set("role_id", selectedRole.userRole.role_id);
      this.ls.set("role", selectedRole.userRole.role_id);
      this.ls.set("user_id", compData.user_info.id);
      this.ls.set("createdBy", compData.user_info.id);
      this.ls.set("vendor_id", compData.user_info.vendor_id);
      this.ls.set("email_address", compData.user_info.email_address);
      this.ls.set("batch_id", compData.user_info.batch_id);
      this.ls.set("section", compData.user_info.section);
      this.ls.set("student_dashboard_section_filter", compData.user_info.vendor_detail.student_dashboard_section_filter);
      this.ls.set("first_name", compData.user_info.first_name);
      this.ls.set("last_name", compData.user_info.last_name);
      this.ls.set("department_id", compData.user_info.department_id);
      this.ls.set("course_id", compData.user_info.course_id);
      this.ls.set("vendor_logo", ven_profile);
      this.ls.set("vendor_sub_logo", ven_sub_admin_profile);
      this.ls.set("password", compData.user_info.password);
      this.ls.set("write_access", compData.user_info.write_access);
      if (compData.user_info.vendor_detail != undefined) {
        this.ls.set(
          "report_permission",
          compData.user_info.vendor_detail.report_permission
        );
        this.ls.set(
          "live_class_permission",
          compData.user_info.vendor_detail.live_class_permission
        );
        this.ls.set(
          "is_student_search_all_video",
          compData.user_info.vendor_detail.is_student_search_all_video
        );
      }
      this.closeModal();
      if (parseInt(this.ls.get("role")) != roleIdSix) {
        window.location.href = location.origin + "/dashboard";
      } else {
        window.location.href = location.origin + "/video-details";
      }

      this.errorMessage = "";
    }
  }

  permissionYes() {
    this.modalService.dismissAll();
    if (this.storageService.notificationIntval) {
      clearInterval(this.storageService.notificationIntval);
    }
    if(this.storageService.getImpersonateTextForUrl() !== '') {
      this.router.navigate([`/dashboard`]);
        let keys: string[] = [
          "role",
          "token",
          "vendor_id",
          "email_address",
          "createdBy",
          "batch_id",
          "first_name",
          "last_name",
          "department_id",
          "course_id",
          "vendor_logo",
          "vendor_sub_logo",
          "password",
          "write_access",
          "user_id",
        ];
        keys.forEach((el) => {
          localStorage.removeItem(`impersonate_${el}`);
        });
    } else {
      this.router.navigate([``]);
        this.ls.removeAll();
        let keys: string[] = [
          "role",
          "token",
          "vendor_id",
          "email_address",
          "createdBy",
          "batch_id",
          "first_name",
          "last_name",
          "department_id",
          "course_id",
          "vendor_logo",
          "vendor_sub_logo",
          "password",
          "write_access",
          "user_id",
        ];
        keys.forEach((el) => {
          localStorage.removeItem(`impersonate_${el}`);
        });
    }
    // this.route.queryParams.subscribe((params) => {
    //   if (params.loginType == "impersonate") {
        
    //   } else {
        
    //   }
    // });
  }
}
